import WithPropertyRole from '@/components/WithPropertyRole';
import SettingsAccess from '../../../../../components/settings/pages/SettingsAccess';
import { CurrentHouseProvider } from '@/context/CurrentHouseContext';
import { Permission } from '@/utils/permissionUtils';

/**
 * Sharing settings page scoped to a specific property via its public ID in the URL.
 */
const SettingsAccessRoute = () => {
	const { userId, tab } = Route.useSearch();
	return (
		<CurrentHouseProvider>
			<WithPropertyRole requiredPermissions={[Permission.HOUSE_ACCESS_MANAGEMENT_MANAGE]}>
				<SettingsAccess initialUserId={userId} initialTab={tab} />
			</WithPropertyRole>
		</CurrentHouseProvider>
	);
};

export const Route = createFileRoute({
	validateSearch: (search: Record<string, unknown>) => {
		const userId = typeof search.userId === 'number' ? search.userId : Number.parseInt(String(search.userId), 10);
		return {
			/**
			 * The person whose access drawer should be open, so another screen can send a reader to one
			 * user rather than to the whole list. The contacts drawer's "Manage this contact's access"
			 * is the first to.
			 */
			userId: Number.isFinite(userId) ? userId : undefined,
			/**
			 * The tab to land on, so a write that moves somebody between Current and History can say
			 * where they went, and a refresh reproduces it.
			 */
			tab:
				search.tab === 'users' || search.tab === 'qrcode' || search.tab === 'history'
					? (search.tab as 'users' | 'qrcode' | 'history')
					: undefined,
		};
	},
	component: SettingsAccessRoute,
});
